import { ClassNameProp, StandaloneComponent } from '@/types/component';
import { StandaloneButton, StandaloneButtonProps } from 'base/components/Button';

export type AllasStandaloneButtonProps = StandaloneButtonProps & {
  colors?: ClassNameProp<'primary' | 'secondary' | 'alternative'>;
};

export const AllasStandaloneButton: StandaloneComponent<AllasStandaloneButtonProps> = (props) => {
  return <StandaloneButton {...props} />;
};

export default AllasStandaloneButton;
